
<ManuallyExpandableImagePreview
    ref="imagePreview"
    :class="{selected: selected}"
    :filter="filter"
    :image="image"
    :small-width="landscape ? '188px' : null"
    class="previewContainer"
    small-height="128px"
    @select="onSelect"
/>
